export default __webpack_public_path__ + "static/media/Advanced Potion Making - Spells_02.4d85380f.jpg";